import * as v from 'valibot';

const getOptionSchema = () => ({
  id: v.string(),
  label: v.string(),
});

export const addressSearchFormSchema = v.object({
  address1: v.optional(v.string()),
  address2: v.optional(v.string()),
  city: v.optional(v.string()),
  country: v.optional(v.object(getOptionSchema())),
  name: v.optional(v.string()),
  postalCode: v.optional(v.string()),
  state: v.optional(v.object(getOptionSchema())),
});

export const addressSearchParamsSchema = v.object({
  ...addressSearchFormSchema.entries,
  limit: v.optional(v.pipe(v.number(), v.minValue(0)), 10),
  offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
  sorting: v.optional(v.string()),
});

export const addressSchema = v.object({
  address1: v.optional(v.string()),
  address2: v.optional(v.string()),
  city: v.string(),
  country: v.string(),
  countryCode: v.optional(v.string()),
  id: v.string(),
  name: v.optional(v.string()),
  postalCode: v.string(),
  state: v.string(),
  stateCode: v.optional(v.string()),
});

const addAddressOptionSchema = (message: string) => ({
  id: v.string(message),
  label: v.string(message),
});

export const addressFormSchema = v.object({
  address1: v.optional(v.string()),
  address2: v.optional(v.string()),
  city: v.string('City is required'),
  country: v.object(addAddressOptionSchema('Country is required')),
  id: v.optional(v.string()),
  name: v.optional(v.string()),
  postalCode: v.pipe(v.string('Postal Code is required'), v.minLength(1, 'Postal Code is required')),
  state: v.object(addAddressOptionSchema('State/Province is required')),
});

export type AddressSearchFormValues = v.InferOutput<typeof addressSearchFormSchema>;
export type AddressSearchParams = v.InferOutput<typeof addressSearchParamsSchema>;
export type Address = v.InferOutput<typeof addressSchema>;

export type AddressFormValues = v.InferInput<typeof addressFormSchema>;

export type AddressItem = Address;
export type Addresses = Address[];

export type AddressBookSearchApi = { data: Addresses; total: number };
